// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","medium":"Card_medium__1O7yg","small":"Card_small__1iFxO","tiny":"Card_tiny__HZzU3"};